module.exports = __webpack_public_path__ + "img/SHIELD.5c6ba238.svg";